"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHotelOrderEndUserStatus = getHotelOrderEndUserStatus;
exports.getTextFromHtml = getTextFromHtml;
exports.isValidHotelId = isValidHotelId;
exports.omitEmptyBoolKeys = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omitBy2 = _interopRequireDefault(require("lodash/omitBy"));
var _constants = require("../constants");
/**
 * is valid hotel id
 * @param hotelId
 * @return {boolean}
 */
function isValidHotelId(hotelId) {
  return new RegExp(/^[0-9]+$/).test(hotelId);
}

/**
 * Hotel Details discription text extraction from html
 * @param {HTMLElement} html
 * @return {String}
 */
function getTextFromHtml(html) {
  var regex = /(<([^>]+)>)/gi,
    result = html.replace(regex, '');
  return result;
}

/**
 * get hotel order end user status
 * @param {Number} paymentStatus
 * @param {Number} bookingStatus
 * @param {Boolean} stayCompleted
 * @return {string}
 */
function getHotelOrderEndUserStatus(_ref) {
  var paymentStatus = _ref.paymentStatus,
    bookingStatus = _ref.bookingStatus,
    stayCompleted = _ref.stayCompleted;
  var PENDING = _constants.PAYMENT_STATUS.PENDING,
    AUTHORIZED = _constants.PAYMENT_STATUS.AUTHORIZED,
    AUTHORIZED_WITH_INSTALLMENTS = _constants.PAYMENT_STATUS.AUTHORIZED_WITH_INSTALLMENTS;
  var CANCELLED = _constants.BOOKING_STATUS.CANCELLED,
    FAILURE = _constants.BOOKING_STATUS.FAILURE,
    SUCCESS = _constants.BOOKING_STATUS.SUCCESS;
  var endUserStatusMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, AUTHORIZED, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW)), AUTHORIZED_WITH_INSTALLMENTS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW)), PENDING, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.PAYMENT_PENDING), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.NOT_CONFIRMED), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER));
  var afterCheckinDateEndUserStatusMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, AUTHORIZED, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW)), AUTHORIZED_WITH_INSTALLMENTS, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW)), PENDING, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, SUCCESS, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER), FAILURE, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER), CANCELLED, _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER));
  return stayCompleted ? (0, _get2["default"])(afterCheckinDateEndUserStatusMap, "".concat(paymentStatus, ".").concat(bookingStatus), _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMING_WITH_HOTEL) : (0, _get2["default"])(endUserStatusMap, "".concat(paymentStatus, ".").concat(bookingStatus), _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMING_WITH_HOTEL);
}
var isValueEmpty = function isValueEmpty(value) {
  return !value;
};
var omitEmptyBoolKeys = exports.omitEmptyBoolKeys = function omitEmptyBoolKeys(payload) {
  return (0, _omitBy2["default"])(payload, isValueEmpty);
};